import { GALLERY } from "../data.types";

const prepareToUpdate = galleries => {
  let gType = GALLERY.toLowerCase();

  const getNames = description => {
    let result = [];

    for (let [key, value] of Object.entries(description)) {
      result.push({
        id: key,
        value
      });
    }

    return result;
  };

  let result = galleries.map(g => {
    return {
      numberInOrder: g.numberInOrder,
      preview: g.preview,
      url: g.url,
      names: getNames(g.description)
    };
  });
  if (result.length > 0 && !result.some(r => r.preview)) {
    result[0].preview = true;
  }

  return {
    data: {
      type: GALLERY,
      [gType]: result
    }
  };
};

const prepareToCopy = (file, objectId, attributeId, lang) => {
  return {
    lang,
    data: {
      objectId,
      attributeId,
      file
    }
  };
};

export { prepareToUpdate, prepareToCopy };
